import { render } from "./ChatMessageBlock.vue?vue&type=template&id=fb82a85a"
import script from "./ChatMessageBlock.vue?vue&type=script&lang=js"
export * from "./ChatMessageBlock.vue?vue&type=script&lang=js"

import "./ChatMessageBlock.vue?vue&type=style&index=0&id=fb82a85a&lang=scss"

import exportComponent from "/var/www/vimashenets/data/www/valera.report.tz365.ru/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__